import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "next-page__button q-col-12 q-d-block q-d-md-none q-pb-3 q-px-2"
}

import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {storeToRefs} from "pinia";
import {inject} from "vue";
import {SmartSearchTranslationsInterface} from "@/core/types";



export default /*@__PURE__*/_defineComponent({
  __name: 'NextPageButton',
  props: ['position'],
  setup(__props) {


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

let {nextPageButtonText} = SmartSearchTranslations.value.pagination

const paginationStore = usePaginationStore();

const {totalPage, page, getNextPage} = storeToRefs(paginationStore)

return (_ctx: any,_cache: any) => {
  return (_unref(page) + 1 < _unref(totalPage))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "q-btn q-btn q-btn-danger q-rounded-3 q-shadow-sm q-w-100",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(paginationStore).setActualPageValue(_unref(getNextPage))))
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(nextPageButtonText)), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})